// extracted by mini-css-extract-plugin
export var hiddenOnDesktop = "Staff-module--hiddenOnDesktop--ee054";
export var list = "Staff-module--list--9c632";
export var noDrag = "Staff-module--noDrag--07d13";
export var section = "Staff-module--section--69b45";
export var tags = "Staff-module--tags--ad6a0";
export var title = "Staff-module--title--f935c";
export var topText = "Staff-module--topText--fa545";
export var wrapper = "Staff-module--wrapper--73f47";